module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-3.369ffa87.png";